export default __webpack_public_path__ + "static/media/cashsweep.d5d0ccf1.png";